import { get } from 'lodash';
const positionLocals = {
    cn: {
        "PAGE": "页",
        "FIG": "图",
        "TABLE": "表",
        "PARAGRAPH": "段落",
        "OTHER": "其他",
        "EXAMPLE": "例",
        "APP": "附录",
        "ANNEX": "附件",
        "NAME_IN_DOCUMENT": "文中描述"
    },
    en: {
        "PAGE": "Page",
        "FIG": "Figure",
        "TABLE": "Table",
        "PARAGRAPH": "Paragraph",
        "OTHER": "Other",
        "EXAMPLE": "Example",
        "APP": "Appendix",
        "ANNEX": "Annex",
        "NAME_IN_DOCUMENT": "Name in Document"
    },
    tw: {
        "PAGE": "頁",
        "FIG": "圖",
        "TABLE": "表",
        "PARAGRAPH": "段落",
        "OTHER": "其他",
        "EXAMPLE": "例",
        "APP": "附錄",
        "ANNEX": "附件",
        "NAME_IN_DOCUMENT": "文中描述"
    },
    jp: {
        "PAGE": "ページ",
        "FIG": "图",
        "TABLE": "テーブル",
        "PARAGRAPH": "段落",
        "OTHER": "その他",
        "EXAMPLE": "例",
        "APP": "付録",
        "ANNEX": "添付ファイル",
        "NAME_IN_DOCUMENT": "ドキュメント内の名前"
    }
};
export const transformSequencePosition = function (position, nos, $tOrLang, i18nPath = 'sequences.position') {
    const isLang = typeof $tOrLang === 'string';
    const curLocal = isLang ? positionLocals[$tOrLang] : positionLocals.en;
    const positionStrArrs = [];
    if (nos.length) {
        positionStrArrs.push(`SEQ ID. ${nos.join(', ')}`);
    }
    const table = get(position, 'TABLE', []);
    if (table.length) {
        positionStrArrs.push(`${isLang ? curLocal['TABLE'] : $tOrLang(`${i18nPath}.TABLE`)} ${table.join(', ')}`);
    }
    const fig = get(position, 'FIG', []);
    if (fig.length) {
        positionStrArrs.push(`${isLang ? curLocal['FIG'] : $tOrLang(`${i18nPath}.FIG`)} ${fig.join(', ')}`);
    }
    const page = get(position, 'PAGE', []);
    if (page.length) {
        positionStrArrs.push(`${isLang ? curLocal['PAGE'] : $tOrLang(`${i18nPath}.PAGE`)} ${page.join(', ')}`);
    }
    const paragraph = get(position, 'PARAGRAPH', []);
    if (paragraph.length) {
        positionStrArrs.push(`${isLang ? curLocal['PARAGRAPH'] : $tOrLang(`${i18nPath}.PARAGRAPH`)} ${paragraph.join(', ')}`);
    }
    const other = get(position, 'OTHER', []);
    if (other.length) {
        positionStrArrs.push(`${isLang ? curLocal['OTHER'] : $tOrLang(`${i18nPath}.OTHER`)} ${other.join(', ')}`);
    }
    const example = get(position, 'EXAMPLE', []);
    if (example.length) {
        positionStrArrs.push(`${isLang ? curLocal['EXAMPLE'] : $tOrLang(`${i18nPath}.EXAMPLE`)} ${example.join(', ')}`);
    }
    const app = get(position, 'APP', []);
    if (app.length) {
        positionStrArrs.push(`${isLang ? curLocal['APP'] : $tOrLang(`${i18nPath}.APP`)} ${app.join(', ')}`);
    }
    const annex = get(position, 'ANNEX', []);
    if (annex.length) {
        positionStrArrs.push(`${isLang ? curLocal['ANNEX'] : $tOrLang(`${i18nPath}.ANNEX`)} ${annex.join(', ')}`);
    }
    const nameInDoc = get(position, 'NAME_IN_DOCUMENT', []);
    if (nameInDoc.length && !positionStrArrs.length) {
        // 因为名称包含'，'，所以用'；'分隔
        positionStrArrs.push(`${isLang ? curLocal['NAME_IN_DOCUMENT'] : $tOrLang(`${i18nPath}.NAME_IN_DOCUMENT`)}: ${nameInDoc.join('; ')}`);
    }
    return positionStrArrs;
};
//# sourceMappingURL=sequenceTool.js.map